import { NewUsersConfig } from "@energylab/shared-components/constants/config/newUsersConfig";

export const newUsersConfig: NewUsersConfig = {
    enabled: true,
    hasListOfNewUsers: true
};
